import { COLOURS } from '../../../ui-kit';

export const COMMENT_VISIBILITY_STYLES = {
  PUBLIC: {
    bgColor: COLOURS.cyan.jungleGreen.monkey,
    textColor: COLOURS.mono.white,
    iconColor: 'monkey',
    icon: 'activity'
  },
  INTERNAL: {
    bgColor: '#6F6866',
    textColor: COLOURS.grey.grayBrown,
    iconColor: 'grayBrown',
    icon: 'group2'
  },
  SHOOTSTA_INTERNAL: {
    bgColor: '#6F6866',
    textColor: COLOURS.grey.grayBrown,
    iconColor: 'grayBrown',
    icon: 'group2'
  }
};